import { useState, useEffect, useReducer } from 'react'
import { Route, useParams, Switch } from 'react-router-dom'

import InventoryTransfer from '../InventoryTransfer'
import InventoryCalibration from '../InventoryCalibration'
import Table from './Table'

import reducer, { initialState } from './state'

const MODULE_PATH = '/operations/:zone+/inventory'

function Inventory() {
  const params = useParams()

  const [state, dispatchState] = useReducer(reducer, initialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Switch>
      <Route path={`${MODULE_PATH}/transfers`}>
        <InventoryTransfer
          organizationId={state.organizationId}
          backPath={modulePath}
        />
      </Route>
      <Route path={`${MODULE_PATH}/calibration`}>
        <InventoryCalibration
          inventoryId={state.inventoryId}
          backPath={modulePath}
        />
      </Route>
      <Route path={MODULE_PATH} exact={true}>
        <Table
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
        />
      </Route>
    </Switch>
  )
}

export default Inventory
